module.exports = __webpack_public_path__ + "img/g2.0d93b0ca.jpg";